import React, { useEffect } from 'react';
import { usePerformanceReport } from '@/hooks/usePerformanceMonitoring';

/**
 * Development-only performance debugging component
 * Shows performance metrics and controls in development mode
 */
export function PerformanceDebugger() {
  // Disabled for production
  return null;
}